// src/utils/storageUtils.js
export const getCoupleId = () => {
    try {
        // 1. user 정보에서 coupleId 조회
        const userData = localStorage.getItem('user');
        if (userData) {
            const parsedUser = JSON.parse(userData);
            if (parsedUser.coupleId) {
                return parsedUser.coupleId;
            }
        }
        
        // 2. coupleInfo에서 coupleId 조회
        const coupleInfo = localStorage.getItem('coupleInfo');
        if (coupleInfo) {
            const parsedCoupleInfo = JSON.parse(coupleInfo);
            if (parsedCoupleInfo.coupleId) {
                return parsedCoupleInfo.coupleId;
            }
        }
        
        return null;
    } catch (error) {
        console.error('coupleId 조회 실패:', error);
        return null;
    }
};

export const getAuthToken = () => {
    return localStorage.getItem('accessToken');
};

export const getUserInfo = () => {
    try {
        const userData = localStorage.getItem('user');
        return userData ? JSON.parse(userData) : null;
    } catch (error) {
        console.error('사용자 정보 파싱 실패:', error);
        return null;
    }
};

export const getCoupleInfo = () => {
    try {
        const coupleInfo = localStorage.getItem('coupleInfo');
        return coupleInfo ? JSON.parse(coupleInfo) : null;
    } catch (error) {
        console.error('커플 정보 파싱 실패:', error);
        return null;
    }
};

// ✅ 추가: formatLocalDate 함수
export const formatLocalDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

// ✅ 추가: parseLocalDate 함수 (필요시 사용)
export const parseLocalDate = (dateString) => {
    // "YYYY-MM-DD" 문자열을 로컬 시간 기준 Date 객체로 변환
    const [year, month, day] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day);
};

// ✅ 추가: 세션 관련 localStorage 일괄 정리 (401 만료·로그아웃 공용)
export const clearSession = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
    localStorage.removeItem('coupleInfo');
    localStorage.removeItem('pendingInvite');
};

// 로그아웃 공용 — 우리 세션을 지운 뒤 카카오 계정 세션까지 끊는다.
// 이 단계가 없으면 로그아웃 후에도 카카오 세션이 브라우저에 남아,
// 공용 PC에서 다음 사람이 로그인 버튼만 눌러 이전 계정으로 들어갈 수 있다.
export const logout = () => {
    if (window.Kakao && window.Kakao.Auth) {
        window.Kakao.Auth.logout(() => {});
    }
    clearSession();
    // 서버가 카카오 로그아웃 주소로 리다이렉트하고, 카카오가 다시 로그인 화면으로 돌려보낸다
    window.location.href = `${process.env.REACT_APP_API_BASE_URL}/auth/kakao-logout`;
};